import { useSelector } from 'react-redux'

import { currentTeamSelector } from '../../../redux/selectors/team'
import { isVendorUserSelector } from '../../../redux/selectors/users'
import { ApplicationState } from '../../../redux/store/models'

export const useShowSideBar = () => {
  const isAuthenticated = useSelector((state: ApplicationState) => state.auth.isAuthenticated)
  const isVendorUser = useSelector(isVendorUserSelector)
  const team = useSelector(currentTeamSelector)

  if (isVendorUser) return true
  if (!team.is_approved) return false
  if (!isAuthenticated) return false
  return true
}
